import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`

:root{
    --background: #D9D9D9;

    /**
     * Default Colors
     */
    --red:#ec0065;
    --purple: #1c0069;
    --blue: #1aacac;
    --blue-light: #2c7da0;
    --green:#1b998b;
    --grey-light: #f5f3f4;
    --grey: #bcb8b1;
    --yellow: #facc15;


    /**
     * Default Type Colors
     */

    --error-text: var(--grey-light);
    --error: var(--red);

    --info-text: #3172b7;
    --info: var(--grey-light);

    --success-text: var(--grey-light);
    --success: #7AA874;
  

    --text-title: #363f5f;
    --text-body: #969cb3;
    --shape: #FFFFFF;

    --sidebar_width: 300px;
}
*{
    margin:0;
    padding: 0;
    box-sizing:border-box;
}
html{
    @media (max-width: 1080px){
        font-size: 93.75%;
    }

    @media (max-width: 720){
        font-size: 87.5%;
    }
}

body{
        background-color: var(--background);
        -webkit-font-smoothing: antialiased;
    }

body, input, textarea, button {
font-family: 'Montserrat', sans-serif;
font-weight: 400;
}

button{
    cursor: pointer;
}
[disabled]{
    opacity: 0.6;
    cursor: not-allowed;
}
`;
